// V4.1.3: Firebase config ve aktivite kaydı
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { collection, addDoc } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCt3PTMEO0oWydm2Q2JnNEcUKlIS5MewUM",
  authDomain: "kumbara-app.firebaseapp.com",
  projectId: "kumbara-app",
  storageBucket: "kumbara-app.firebasestorage.app",
  messagingSenderId: "893704882172",
  appId: "1:893704882172:web:2a73b725fa6c2a6ea25479"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);

// V5.8: Functions Emulator bağlantısı (sadece development için)
if (process.env.NODE_ENV === 'development') {
  try {
    // Emulator bağlantısını kontrol et (güvenli)
    const isConnected = functions._delegate?._url || functions._delegate?._customDomain;
    if (!isConnected) {
      connectFunctionsEmulator(functions, 'localhost', 5001);
      console.log('✅ Functions Emulator bağlandı: localhost:5001');
    }
  } catch (error) {
    console.warn('⚠️ Functions Emulator bağlantı hatası (normal, production\'da çalışır):', error);
  }
}

// V5.8: HTTP Callable Functions
export const setCustomClaims = httpsCallable(functions, 'setCustomClaims');
export const syncPassword = httpsCallable(functions, 'syncPassword');
export const deleteFirebaseAuthUser = httpsCallable(functions, 'deleteFirebaseAuthUser');

// Aktivite kaydı fonksiyonu
export const aktiviteKaydet = async (kullaniciAd, aktivite, detay = '') => {
  try {
    await addDoc(collection(db, 'aktiviteler'), {
      kullaniciAd: kullaniciAd,
      aktivite: aktivite,
      detay: detay,
      tarih: new Date()
    });
  } catch (error) {
    console.error('Aktivite kaydı hatası:', error);
  }
};

